import React from 'react'

import { SuggestionProps } from './types'
import styles from './index.module.scss'

const Suggestion = ({ item }: SuggestionProps) => (
  <div>
    <div className={styles.autoSuggest__suggestion__label}>{item.label}</div>
    {item.description && (
      <div className={styles.autoSuggest__suggestion__description}>
        {item.description}
      </div>
    )}
  </div>
)

export default Suggestion
